import { useRef } from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";
import { useReducedFx } from "./motion-utils";

/**
 * Full-viewport cinematic scene: a single clean lab background drifts slowly
 * (subtle parallax), with a readability vignette. Foreground content sits on top.
 */
export const ParallaxScene = ({ id, bg, children, className = "", tint = "" }) => {
  const ref = useRef(null);
  const reduced = useReducedFx();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const p = useSpring(scrollYProgress, { stiffness: 80, damping: 26, restDelta: 0.001 });

  const bgY = useTransform(p, [0, 1], ["-6%", "6%"]);

  return (
    <section id={id} ref={ref} className={`cg-scene ${className}`} data-testid={`scene-${id}`}>
      <motion.div
        className="cg-scene-bg"
        style={reduced ? { backgroundImage: `url(${bg})` } : { backgroundImage: `url(${bg})`, y: bgY }}
      />
      <div className={`cg-scene-vignette ${tint}`} />
      <div className="relative z-10 w-full">{children}</div>
    </section>
  );
};
